import http from "./http";

export default {
    getUserId(params){
        return http.post("common-user/user/default/getBaseInfo", params);
    },
}
